/**
 *
 * GSTR-9C New Save Actions
 *
 */
import axios from "axios";
import { Config } from "../../../Config.js";
import { getLocalStorage } from "components/Helper/Helper";
import { errorToastMessage, successToastMessage } from "utils/errorToast";
import {
  LOADER_STATUS,
  SET_SAVE_TABLE_DATA,
  SET_FETCH_TABLE_DATA,
  SET_SELECTED_SAVE,
  SET_SELECTED_ROW_SAVE,
  SET_SELECTED_FETCH,
  SET_SELECTED_ROW_FETCH,
} from "./constants";

// Loader Action
export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

// Table Data Actions
export function setSaveTableData(saveTableData) {
  return {
    type: SET_SAVE_TABLE_DATA,
    saveTableData,
  };
}

export function setFetchTableData(fetchTableData) {
  return {
    type: SET_FETCH_TABLE_DATA,
    fetchTableData,
  };
}

// Selection Management Actions - Save Tab
export function setSelectedSave(selectedRows) {
  return {
    type: SET_SELECTED_SAVE,
    selectedRows,
  };
}

export function setSelectedRowSave(selectedRowData) {
  return {
    type: SET_SELECTED_ROW_SAVE,
    selectedRowData,
  };
}

// Selection Management Actions - Fetch Tab
export function setSelectedFetch(selectedRows) {
  return {
    type: SET_SELECTED_FETCH,
    selectedRows,
  };
}

export function setSelectedRowFetch(selectedRowData) {
  return {
    type: SET_SELECTED_ROW_FETCH,
    selectedRowData,
  };
}

/* Clear all selected states for both Save and Fetch tabs */
export function clearAllSelectedStates() {
  return (dispatch) => {
    dispatch(setSelectedSave([]));
    dispatch(setSelectedRowSave([]));
    dispatch(setSelectedFetch([]));
    dispatch(setSelectedRowFetch([]));
  };
}

export const getSaveSubmitData = (
  selectedGstinList,
  selectedReturnPeriod,
  isToast=true
) => {
  return async (dispatch) => {
    const data = {
      gstin: selectedGstinList,
      fiscal_year: selectedReturnPeriod,
      activeTab : 1
    };

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR9c/submitGstr9cSaveDataHistory`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error == "0") {
        if (isToast)
          successToastMessage(response.data.msg || "Data fetched successfully");
        
        // Transform data with unique key IDs before storing in Redux
        const originalData = response.data.data || [];
        const transformedData = originalData.map((item, index) => {
          // Create truly unique key ID using file_id, gstin, and timestamp
          const uniqueKeyId = `${item.gstin || item.GSTIN || selectedGstinList[0] || 'unknown'}_${item.file_id || item.FILE_ID || Date.now()}_${item.created_date || new Date().getTime()}_save_${index}`;
          
          return {
            ...item,
            uniqueId: uniqueKeyId // Add unique ID to each item
          };
        });
        
        console.log("🔍 getSaveSubmitData - Transformed data:", transformedData);
        console.log("🔍 Unique IDs:", transformedData.map(item => item.uniqueId));
        dispatch(setSaveTableData(transformedData));
        return transformedData;
      } else {
        if (isToast)
          errorToastMessage(response.data.msg || "Failed to fetch data");
        dispatch(setSaveTableData([]));
        return [];
      }
    } catch (error) {
      console.log("Error in getSaveSubmiData:", error);
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getFetchSubmitData = (
  selectedGstinList,
  selectedReturnPeriod,
  isToast
) => {
  return async (dispatch) => {
    const data = {
      gstin: selectedGstinList,
      fiscal_year: selectedReturnPeriod,
      activeTab:2
    };

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR9c/submitGstr9cSaveDataHistory`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error == "0") {
        if (isToast)
          successToastMessage(
            response.data.msg || "Fetch data retrieved successfully"
          );
        
        // Transform data with unique key IDs before storing in Redux
        const originalData = response.data.data || [];
        const transformedData = originalData.map((item, index) => {
          // Create truly unique key ID using file_id, gstin, and timestamp
          const uniqueKeyId = `${item.gstin || item.GSTIN || selectedGstinList[0] || 'unknown'}_${item.file_id || item.FILE_ID || Date.now()}_${item.created_date || new Date().getTime()}_fetch_${index}`;
          
          return {
            ...item,
            uniqueId: uniqueKeyId // Add unique ID to each item
          };
        });
        
        console.log("🔍 getFetchSubmitData - Transformed data:", transformedData);
        console.log("🔍 Unique IDs:", transformedData.map(item => item.uniqueId));
        dispatch(setFetchTableData(transformedData));
        return transformedData;
      } else {
        if (isToast)
          errorToastMessage(response.data.msg || "Failed to fetch data");
        dispatch(setFetchTableData([]));
        return [];
      }
    } catch (error) {
      console.log("Error in getFetchSubmitData:", error);
      if (isToast) errorToastMessage("Error occurred while fetching data");
      dispatch(setFetchTableData([]));
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
};

export const saveToGstn = (selectedRowData) => {
  return async (dispatch) => {
    const data = {
      selectedRowData,
    };

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR9c/saveGstr9cSaveDataToGstin`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error === 0) {
        successToastMessage(
          response.data.msg || "Fetch data retrieved successfully"
        );
        return response.data.data || [];
      } else {
        errorToastMessage(response.data.msg || "Failed to fetch data");
        return [];
      }
    } catch (error) {
      console.log("Error in getFetchSubmitData:", error);
      errorToastMessage("Error occurred while fetching data");
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
};

export const downloadJson =
  (selectedRowSave) => async (dispatch) => {
    dispatch(loader(true));
    const data = {
     selectedRowData: selectedRowSave
    };
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR9c/downloadSaveGstr9cJsonData`,
        headers: { token: getLocalStorage("loginDetails") },
        responseType: "blob",
        data: data,
      });

      // Only allow download if status code is 200
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Gstr9c_JSON.zip");
        document.body.appendChild(link);
        link.click();

        link.remove();
        URL.revokeObjectURL(url);
        successToastMessage("File downloaded successfully");
      } else {
        console.log(
          "Download failed: Status code is not 200. Received:",
          response.status
        );
        errorToastMessage("Download failed. Please try again.");
      }
    } catch (error) {
      console.log("Error in downloadJson:", error);
      errorToastMessage("Error occurred while downloading file.");
    } finally {
      dispatch(loader(false));
    }
  };

export const downloadReport = (selectedRowData) => async (dispatch) => {
  dispatch(loader(true));
  // const data = {
  //   selectedRowData
  // };
  try {
    const response = await axios({
      method: "post",
      url: `${Config.url}gstR9c/downloadGstr9cSaveHistoryReport`,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: selectedRowData,
    });

    // Only allow download if status code is 200
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Gstr9c_Report.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);
      successToastMessage("File downloaded successfully");
    } else {
      console.log(
        "Download failed: Status code is not 200. Received:",
        response.status
      );
      errorToastMessage("Download failed. Please try again.");
    }
  } catch (error) {
    console.log("Error in downloadReport:", error);
    errorToastMessage("Error occurred while downloading file.");
  } finally {
    dispatch(loader(false));
  }
};

export const downloadFetchReport = (selectedRowData) => async (dispatch) => {
  dispatch(loader(true));
  const data = {
    selectedRowData,
  };
  try {
    const response = await axios({
      method: "post",
      url: `${Config.url}gstR9c/downloadGstr9cFetchReportSummary`,
      headers: { token: getLocalStorage("loginDetails") },
      responseType: "blob",
      data: data,
    });

    // Only allow download if status code is 200
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Gstr9c_Report_Summary.zip");
      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(url);
      successToastMessage("File downloaded successfully");
    } else {
      console.log(
        "Download failed: Status code is not 200. Received:",
        response.status
      );
      errorToastMessage("Download failed. Please try again.");
    }
  } catch (error) {
    console.log("Error in downloadReport:", error);
    errorToastMessage("Error occurred while downloading file.");
  } finally {
    dispatch(loader(false));
  }
};

export const fetchSummary = (selectedGstinList, selectedReturnPeriod) => {
  return async (dispatch) => {
     const data = {
     selected_return_period: selectedReturnPeriod,
     selected_gstin_list: selectedGstinList
    };

    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gstR9c/fetchGstr9cSummary`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error == 0) {
        successToastMessage(
          response.data.msg || "Fetch data retrieved successfully"
        );
        return response.data.data || [];
      } else {
        errorToastMessage(response.data.msg || "Failed to fetch data");
        return [];
      }
    } catch (error) {
      console.log("Error in fetchSummary:", error);
      errorToastMessage("Error occurred while fetching data");
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
};

/* Transform data for GSTR9 Component with unique key ID */
export const transformDataForGSTR9Component = (tableNumber, data, gstin = "", entity = "", fiscalYear = "") => {
  // Transform the dialog data format to match SaveGstr9 component expectations
  // This is a basic transformation - you may need to adjust based on actual data structure

  if (!data || data.length === 0) return {};

  // Create a structure that matches what SaveGstr9 components expect
  const transformed = {};

  data.forEach((item, index) => {
    // Create truly unique key ID using multiple identifiers
    const uniqueKeyId = `${gstin || item.gstin || item.GSTIN || 'unknown'}_${entity || item.entity || 'entity'}_${fiscalYear || ''}_${item.file_id || item.FILE_ID || Date.now()}_transform_${index}`;
    
    // Create a generic key structure that most components can handle
    const key = `item_${index}`;
    transformed[key] = {
      uniqueId: uniqueKeyId, // Add the unique key ID
      txval: item.txval || item.taxable_value || item.value || 0,
      iamt: item.iamt || item.igst || 0,
      camt: item.camt || item.cgst || 0,
      samt: item.samt || item.sgst || 0,
      csamt: item.csamt || item.cess || 0,
      // Additional fields that might be needed
      gstin: item.gstin || item.GSTIN || item.ctin,
      trade_name: item.trade_name || item.lgnm || item.name,
      ...item // Include all original fields
    };
  });

  console.log("🔄 transformDataForGSTR9Component - Transformed:", {
    tableNumber,
    originalCount: data.length,
    transformedKeys: Object.keys(transformed),
    uniqueIds: Object.values(transformed).map(item => item.uniqueId)
  });

  return transformed;
};